export default __webpack_public_path__ + "static/media/trust-zenfuse.7cb7b27f.svg";